
    import Chart from 'chart.js';
    import { Doughnut } from 'vue-chartjs';

    // Creating rounded corners for doughnut graph
    Chart.pluginService.register({
        afterDraw(chart, ease) {
            const { ctx } = chart;
            const easingDecimal = ease || 1;
            const arcs = chart.getDatasetMeta(0).data;
            const dataset = chart.data.datasets[0].data;

            Chart.helpers.each(arcs, (arc, i) => {
                arc.transition(easingDecimal).draw();

                const pArc = arcs[i === 0 ? arcs.length - 1 : i - 1];
                const pColor = pArc._view.backgroundColor;

                const vm = arc._view;
                const radius = (vm.outerRadius + vm.innerRadius) / 2;
                const thickness = (vm.outerRadius - vm.innerRadius) / 2;
                const startAngle = Math.PI - vm.startAngle - Math.PI / 2;
                const angle = Math.PI - vm.endAngle - Math.PI / 2;

                ctx.save();
                ctx.translate(vm.x, vm.y);

                ctx.fillStyle = i === 0 ? vm.backgroundColor : pColor;
                if (dataset[i] === 0) {
                    vm.backgroundColor = pColor;
                }

                ctx.beginPath();
                ctx.arc(radius * Math.sin(startAngle), radius * Math.cos(startAngle), thickness, 0, 2 * Math.PI);
                ctx.fill();

                ctx.fillStyle = vm.backgroundColor;
                ctx.beginPath();
                ctx.arc(radius * Math.sin(angle), radius * Math.cos(angle), thickness, 0, 2 * Math.PI);
                ctx.fill();

                ctx.restore();
            });
        },
    });

    export default {
        extends: Doughnut,
        props: ['chartData', 'options'],
        mounted() {
            this.renderChart(this.chartData, this.options);
        },
        methods: {
            update() {
                this.$data._chart.update();
            },
        },
    };
